import React, { type ComponentType, useMemo, Component } from 'react';
import type { LicensedProducts } from '@atlassian/jira-shared-types/src/tenant-context.tsx';
import { useLicensedProducts } from '@atlassian/jira-tenant-context-controller/src/components/licensed-products/index.tsx';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import type { CompassEntitlementCheckResponse } from './types.tsx';

const isCompassInLicensedProducts = (licensedProducts: LicensedProducts): boolean =>
	(licensedProducts && licensedProducts.compass) || false;

export const useCompassEntitlementCheckService = (): CompassEntitlementCheckResponse => {
	const licensedProducts = useLicensedProducts();

	const memoisedData = useMemo(
		() => isCompassInLicensedProducts(licensedProducts),
		[licensedProducts],
	);

	return { isCompassLicensed: memoisedData };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withCompassEntitlementCheck(WrappedComponent: ComponentType<any>, origin: string) {
	// eslint-disable-next-line jira/react/no-class-components
	return class extends Component {
		render() {
			return (
				<>
					<TenantContextSubscriber>
						{({ tenantContext: { licensedProducts } }) => (
							<WrappedComponent
								isCompassLicensed={isCompassInLicensedProducts(licensedProducts)}
								origin={origin}
								{...this.props}
							/>
						)}
					</TenantContextSubscriber>
				</>
			);
		}
	};
}
